import { isPast } from "../date/isPast.js";
const customLocalStorage = {
    setItem: (keyName, keyValue)=>{
        try {
            return window.localStorage.setItem(keyName, keyValue);
        } catch (error) {
            console.log('Error to set item to localStorage', error);
            return null;
        }
    },
    getItem: (keyName)=>{
        try {
            return window.localStorage.getItem(keyName);
        } catch (error) {
            console.log('Error to get item from localStorage', error);
            return null;
        }
    },
    removeItem: (keyName)=>{
        try {
            return window.localStorage.removeItem(keyName);
        } catch (error) {
            console.log('Error to remove item from localStorage', error);
            return;
        }
    },
    clear: ()=>{
        try {
            return window.localStorage.clear();
        } catch (error) {
            console.log('Error to clear all items from localStorage', error);
            return null;
        }
    },
    clearExpiredKeys: ()=>{
        const expirableLocalStorageKeys = [
            'CREHANA__USER_JUST_LOGGED'
        ];
        try {
            expirableLocalStorageKeys.forEach((localStorageKey)=>{
                const storedDate = window.localStorage.getItem(localStorageKey);
                if (storedDate && isPast(new Date(storedDate))) window.localStorage.removeItem(localStorageKey);
            });
        } catch (error) {
            console.error('Clear local storage expired keys');
        }
    }
};
const src_customLocalStorage = customLocalStorage;
export default src_customLocalStorage;
